<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from 'echarts'
export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '170px'
    },
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    data() {
      this.initChart();
    }
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      var that = this;

      var chart = echarts.init(document.getElementById(that.id));

      var option = {
        color: '#68E6C1',
        legend: {
          top: 10,
          itemWidth: 20,
          itemHeight: 11,
          itemGap: 13,
          right: '7%',
          textStyle: {
            // color: '#fff'
          }
        },
        // 保存为图片
        // toolbox: {
        //   top: 4,
        //   right: '1.5%',
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        grid: {
          top: '20%',
          left: '5%',
          right: '5%',
          bottom: '5%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            lineStyle: {
              // color: '#fff'
            }
          }
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: 0, color: '#606266', rotate: 18, align: 'center', margin: 15,
            textStyle: {
              fontSize: 10 // 更改坐标轴文字大小
            }
          },
          data: that.data.labels,
          axisTick: {
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              // color: '#fff'
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              // color: '#fff'
            },
            axisLine: {
              lineStyle: {
                // color: '#fff'
              }
            },
            max: that.getMaxVal()
          }
        ],
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [
          {
            name: '数量',
            type: 'bar',
            barWidth: '60%',
            // label: {
            //   show: true,
            //   position: 'inside',
            //   color: '#fff',
            //   fontSize: '13px'
            // },
            data: that.data.values,
            itemStyle: {
              barBorderRadius: 1,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#80FFA5' },
                { offset: 1, color: '#01BFEC' }
              ])
            }
          }
        ]
      };
      chart.clear();
      chart.setOption(option);
    },
    getMaxVal() {
      var that = this
      var maxVal = 0
      for (let index = 0; index < that.data.values.length; index++) {
        const item = that.data.values[index]
        if (item > maxVal) {
          maxVal = item
        }
      }
      maxVal += 1
      // 如果是单数
      if (maxVal % 2 !== 0) {
        maxVal += 1
      }
      if (maxVal < 4) {
        maxVal = 4
      }
      return maxVal
    }
  }
};
</script>
